import Vue from 'vue';

import Datepicker from 'vuejs-datepicker';
import { ClientTable, ServerTable } from 'vue-tables-2';

import WebContent from '@/components/_liferay/WebContent';
import intersect from '@/js/directives/intersect';


// Accordion
import AccordionContainer from '@/components/accordion/AccordionContainer';
import AccordionContainerPanel from '@/components/accordion/AccordionContainerPanel';
import AccordionContainerHeader from '@/components/accordion/AccordionContainerHeader';
import AccordionContainerHeaderButton from '@/components/accordion/AccordionContainerHeaderButton';

// Disclosure
import DisclosureButton from '@/components/disclosure/DisclosureButton';
import DisclosureContainer from '@/components/disclosure/DisclosureContainer';

// Carousel
import CarouselItem from '@/components/carousel/CarouselItem';
import CarouselButton from '@/components/carousel/CarouselButton';
import CarouselProgress from '@/components/carousel/CarouselProgress';
import CarouselContainer from '@/components/carousel/CarouselContainer';
import CarouselIndicators from '@/components/carousel/CarouselIndicators';

// Story filter aka Content Collection
import StoryFilter from '@/components/Campaign/CampaignStoriesFilter';

// Tabs
import TabsContainer from '@/components/tabs/TabsContainer';
import TabsContainerTablist from '@/components/tabs/TabsContainerTablist';
import TabsContainerTabpanel from '@/components/tabs/TabsContainerTabpanel';
import TabsContainerTablistTab from '@/components/tabs/TabsContainerTablistTab';

// Base Jump Link
import BaseJumpLink from '@/components/BaseJumpLink';

// Transitions
import TransitionSlide from '@/components/transitions/TransitionSlide';

if(document.getElementsByClassName('journal-content-article').length > 0){
	window.axios = require('axios');

	// Dependecies
	require('intersection-observer');
	Vue.directive('intersect', intersect);


	// Accordion
	Vue.component('AccordionContainer', AccordionContainer);
	Vue.component('AccordionContainerPanel', AccordionContainerPanel);
	Vue.component('AccordionContainerHeader', AccordionContainerHeader);
	Vue.component('AccordionContainerHeaderButton', AccordionContainerHeaderButton);

	// Disclosure
	Vue.component('DisclosureButton', DisclosureButton);
	Vue.component('DisclosureContainer', DisclosureContainer);

	// Carousel
	Vue.component('CarouselItem', CarouselItem);
	Vue.component('CarouselButton', CarouselButton);
	Vue.component('CarouselProgress', CarouselProgress);
	Vue.component('CarouselContainer', CarouselContainer);
	Vue.component('CarouselIndicators', CarouselIndicators);

	// Story filter aka Content Collection
	Vue.component('StoryFilter', StoryFilter);

	// Tabs
	Vue.component('TabsContainer', TabsContainer);
	Vue.component('TabsContainerTablist', TabsContainerTablist);
	Vue.component('TabsContainerTabpanel', TabsContainerTabpanel);
	Vue.component('TabsContainerTablistTab', TabsContainerTablistTab);


	// Base Jump Link
	Vue.component('BaseJumpLink', BaseJumpLink);

	// Transitions
	Vue.component('TransitionSlide', TransitionSlide);

	// DatePicker
	Vue.component('DatePicker', Datepicker);

	// Table
	Vue.use(ClientTable, {}, false, 'bulma', 'footerPagination');
	Vue.use(ServerTable, {}, false, 'bulma', 'footerPagination');


	/* eslint-disable no-new */
	new Vue(WebContent).$mount('.journal-content-article');
}



// WEBPACK FOOTER //
// ./src/js/_liferay/web-content.js